import { featureConfig, User } from '@interfaces';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import * as UserActions from './user.actions';

export const USER_FEATURE_KEY = 'user';

export interface UserState extends EntityState<User> {
  featureFlags: featureConfig | null;
  user: User | null;
}

export interface UserPartialState {
  readonly [USER_FEATURE_KEY]: UserState;
}

export const userAdapter: EntityAdapter<User> = createEntityAdapter<User>();

export const initialUserState: UserState = userAdapter.getInitialState({
  featureFlags: null,
  user: null,
});

const reducer = createReducer(
  initialUserState,

  on(UserActions.setUserFeatureFlags, (state, { featureFlags }) => {
    return {
      ...state,
      featureFlags,
    };
  }),

  on(UserActions.setUser, (state, { user }) => {
    return {
      ...state,
      user,
    };
  }),
);

export function userReducer(state: UserState | undefined, action: Action) {
  return reducer(state, action);
}
